export default class MainStage {
  constructor(element) {
    this.$element = $(element);
    this.animationDelay = 1000;
    this.busy = false;
  }

  show(src) {
    if (this.busy) {
      return;
    }
    this.busy = true;

    this.$element.addClass('visible');
    window.setTimeout(() => {
      this.$element.addClass('curtains-open');
      window.scrollTo({
        top: this.$element.offset().top - 30,
        left: 0,
        behavior: 'smooth',
      });
    }, 0);
    window.setTimeout(() => {
      this.$element.find('.main-stage-content').append(
        $('<iframe></iframe>')
          .addClass('embed-responsive-item')
          .attr({
            src,
            frameborder: '0',
            allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
            allowfullscreen: true,
          })
      );
      this.busy = false;
    }, this.animationDelay);
  }

  hide() {
    if (this.busy) {
      return;
    }
    this.busy = true;
    this.$element.removeClass('curtains-open');
    window.setTimeout(() => {
      this.$element.removeClass('visible');
      this.$element.find('.main-stage-content').empty();
      this.busy = false;
    }, this.animationDelay);
  }
}
